module.exports = `

.react-jinke-music-player-main svg:active, .react-jinke-music-player-main svg:hover {
    color: #fd971f
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #fd971f
}

.react-jinke-music-player-main ::-webkit-scrollbar-thumb {
    background-color: #fd971f;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #fd971f
}

.react-jinke-music-player-main .audio-item.playing svg {
    color: #fd971f
}

.react-jinke-music-player-main .audio-item.playing .player-singer {
    color: #fd971f !important
}

.react-jinke-music-player-main .lyric-btn {
    color: #f8f8f2 !important
}

.react-jinke-music-player-main .lyric-btn-active svg {
    color: #fd971f !important
}

.music-player-lyric {
    color: #fd971f !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #fd971f
}
.audio-lists-panel-content .audio-item:active .group:not([class=".player-delete"]) svg, .audio-lists-panel-content .audio-item:hover .group:not([class=".player-delete"]) svg {
    color: #fd971f
}

.progress-bar-content .audio-title a {
    color: #f8f8f2
}

`
